module.exports = __webpack_public_path__ + "static/comprimida-07652efc344c6f4f4e80a759e806eff7.jpg";